import Vue from 'vue'
import store from 'vuex-store'

export default {
  endpoint: 'cmslogin',
  async post (data) {
    try {
      var result = await Vue.http.post(this.endpoint, data)
      store.commit('setProfile', result.body)
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },
}



// WEBPACK FOOTER //
// ./src/application/cmslogin.js